import { render } from "./RoomingList.vue?vue&type=template&id=bac87346&scoped=true&ts=true"
import script from "./RoomingList.vue?vue&type=script&lang=ts"
export * from "./RoomingList.vue?vue&type=script&lang=ts"

import "./RoomingList.vue?vue&type=style&index=0&id=bac87346&scoped=true&lang=css"

import exportComponent from "C:\\Users\\cpinkney\\Documents\\Dev\\GroupTrips3\\grouptrips-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bac87346"]])

export default __exports__